import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import styles from './ContentHeaderNew.css'
import { ROUTES } from '../../constants'
import PatientIcon from 'static/images/icons/add-plus.svg'
import BackIcon from 'static/images/icons/chevron-left.svg'
import PageUpdated from '../../components/PageUpdated'
import history from '../History'
import { checkIdtfFeatureEnabled } from '../../../configs'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import BreadcrumbNav from '../../../views/components/BreadcrumbNavigation'
import PatientInfoHeader from '../PatientInfoHeader'

const ContentHeader = props => {
  const {
    showAddPatient = true,
    showCTA,
    ctaComponent: CTAComponent,
    text,
    getText,
    hasTabs,
    showLastRefresh = true,
    isLoading,
    lastUpdated,
    handleOnRefreshClick,
    enableBackButton = false,
    className,
    isFullWidth = false,
    enrollPatient = false,
    me,
    backButtonIconShow = true,
    backButtonText,
    showBreadcrumbNavigation = false, // true will render breadcrumb navigation [KPW-2484]
    showPatientInfoHeader = false, // true and has patient will render patient details inside content header [KPW-2484]
    patient,
    renderNewUI = false, // true will render the header with updated UI [KPW - 2484]
    connectionInfo,
  } = props

  const headerClassNames = classNames({
    [styles.header]: !hasTabs,
    [styles.headerWithTabs]: hasTabs,
    [className]: className !== undefined,
  })
  const headerTextcn =
    enableBackButton && !renderNewUI
      ? styles.headerTextWithBack
      : styles.headerText
  const widthController = isFullWidth
    ? styles.contentHeaderFullWidth
    : styles.contentHeaderLeftGroup
  const checkIDTFEnabled = me && checkIdtfFeatureEnabled(me)
  const { backText } = styles
  return (
    <header className={headerClassNames} data-version="v2">
      {enableBackButton && !renderNewUI && (
        <div className={styles.backButton}>
          <button
            onClick={() => history.goBack()}
            className={styles.back}
            data-action="content-header-back"
          >
            {backButtonIconShow ? (
              <BackIcon />
            ) : (
              <p className={backText}>{backButtonText}</p>
            )}
          </button>
        </div>
      )}
      <div className={styles.contentWrapper}>
        {(text ||
          getText ||
          (showCTA && CTAComponent) ||
          (checkIDTFEnabled && enrollPatient) ||
          showAddPatient) && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <div className={widthController}>
              {text && !getText && (
                <h1 className={headerTextcn}>
                  {text}
                  <span className={styles.headerLine} />
                </h1>
              )}
              {!text && getText && getText() && (
                <Box>
                  {getText()}
                  {renderNewUI && <span className={styles.headerLine} />}
                </Box>
              )}
            </div>
            <div className={styles.contentHeaderRightGroup}>
              {showCTA && CTAComponent}
              {checkIDTFEnabled && enrollPatient && (
                <div data-action="add-patient" style={{ marginRight: '10px' }}>
                  <Link
                    to={`${ROUTES.PATIENT_ENROLLMENT}?isEdit=false`}
                    className={styles.addPatientBtn}
                  >
                    <PatientIcon />
                    <FormattedMessage id="button.enroll_patient" />
                  </Link>
                </div>
              )}
              {showAddPatient && (
                <div data-action="add-patient">
                  <Link
                    to={ROUTES.PATIENTS_ADD_NEW_PATIENT}
                    className={styles.addPatientBtn}
                  >
                    <PatientIcon />
                    <FormattedMessage id="button.add_patient" />
                  </Link>
                </div>
              )}
            </div>
          </Box>
        )}
        {showBreadcrumbNavigation && (
          <BreadcrumbNav me={me} connectionInfo={connectionInfo} />
        )}
        {(showPatientInfoHeader || showLastRefresh) && (
          <Box display="flex" justifyContent="space-between" marginTop={2}>
            {showPatientInfoHeader &&
              (!Object.prototype.hasOwnProperty.call(props, 'patient') ? (
                <Box className={styles.root}>
                  <Typography color="secondary">
                    <FormattedMessage id="notfound.patient_details" />
                  </Typography>
                </Box>
              ) : (
                <PatientInfoHeader patient={patient} me={me} />
              ))}
            {showLastRefresh && (
              <PageUpdated
                isLoading={isLoading}
                lastUpdated={lastUpdated}
                handleOnClick={handleOnRefreshClick}
                hasTabs={hasTabs}
                me={me}
                useNewStyles={renderNewUI}
              />
            )}
          </Box>
        )}
      </div>
    </header>
  )
}

export default ContentHeader



// WEBPACK FOOTER //
// ./src/legacy/containers/ContentHeader/ContentHeaderNew.jsx